import {AwsRum} from "aws-rum-web";

type AWSRum = {
    recordError: (err: unknown) => void,
    recordPageView: (path: string) => void
}
let awsRum: AWSRum = {
    recordError: console.error,
    recordPageView: () => {}
}

try {
    awsRum = new AwsRum(
        import.meta.env.VITE_AWS_RUM_APPLICATION_ID,
        '1.0.0',
        import.meta.env.VITE_AWS_RUM_REGION,
        {
            sessionSampleRate: 1 ,
            endpoint: import.meta.env.VITE_AWS_RUM_ENDPOINT,
            telemetries: ["errors", "http", "performance"],
            allowCookies: false,
            enableXRay: false,
            signing: false,
            disableAutoPageView: true
        }
    );
} catch {
    // Ignore errors thrown during CloudWatch RUM web client initialization
}

export default awsRum
